export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_SORT_DISCOUNT = "GET_PRODUCTS_SORT_DISCOUNT";
